import { FreimaurerPerson } from '../model/freimaurer';
import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface FreimaurerPersonSearchParams extends Partial<FreimaurerPerson>, AbstractSearchParams {}

export class FreimaurerPersonRepository extends RepositoryNocoDbBase<FreimaurerPerson, FreimaurerPersonSearchParams> {
  protected readonly TABLE_NAME = 'freimaurer_person';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD: 'CreatedAt';

  protected readonly RELEVANCE_FIELD: 'rating';

  protected readonly SELECT_FILTERS = [];
  protected readonly SEARCH_FIELDS: (keyof FreimaurerPerson)[] = ['name'];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
